export const TOP_BAR_DEFAULT_BUTTON_CLASSNAME =
	'bg-container-bg hover:bg-button-disabled';

export const TOP_BAR_MOBILE_PADDING = { horizontal: 12, vertical: 8 };
